module.exports = __webpack_public_path__ + "static/media/sclogo.09aa288c.jpg";